export const getUrl = (website: string) =>
  !website.startsWith("http") ? `https://${website}` : website;
